import {Alert, Box, LinearProgress, Typography} from "@mui/material";

import React, {useEffect, useState, useMemo} from "react";
import {searchCar} from "../serverREST";
import {VirtualizedCarCard} from "./VirtualizedCarCard"
import {useDispatch, useSelector} from "react-redux";
import {setListsSearch} from "../redux/listsSlice";

function ListStatistics({status, data}) {
    if (status !== "success" || data.length === 0) return null;

    const result = data.reduce((acc, workorder) => {
        const jobs = workorder.jobs || [];
        acc.workOrders++;
        jobs.forEach(job => {

            const isRecommendation = job.repair_tips === true;
            const isDetailOnly = job?.detail?.detailOnly === true;
            if (isRecommendation) {
                acc.recommendationsCount += 1;
                return;
            }

            if (job?.detail) {
                acc.totalDetailSum += job?.detail?.price || 0;
            }
            if (job?.job_id) {
                acc.worksCount += 1;
                acc.totalWorkSum += job.hourPrice * job.sdh_hour * job.difficulty;
                acc.totalHours += job.sdh_hour;
            }

        });

        return acc;
    }, {
        worksCount: 0,
        totalWorkSum: 0,
        totalDetailSum: 0,
        totalHours: 0,
        recommendationsCount: 0,
        workOrders: 0
    });
    return (
        <Alert severity="none" sx={{m: 1}} color={'info'}>
            <Typography variant="body2" color="text.secondary" component="div">
                <Typography variant="caption" component="div"
                            display="block">Заказ-нарядов: {result.workOrders}</Typography>
                <Typography variant="caption" component="div"
                            display="block">Нормо-часов: {Number(result.totalHours.toFixed(2))}</Typography>
                <Typography variant="caption" component="div"
                            display="block">Средний
                    заказ-наряд: {(result.totalHours / result.workOrders).toFixed(2)} ч.</Typography>
                <Typography variant="caption" component="div"
                            display="block">Сумма за работы: {Number(result.totalWorkSum.toFixed(2))}</Typography>
                <Typography variant="caption" component="div"
                            display="block">Сумма за запчасти: {Number(result.totalDetailSum.toFixed(2))}</Typography>
                {/*
                <Typography variant="caption" component="div"
                            display="block">Сумма за работы: {Number(result.totalSum.toFixed(2))}</Typography>

                <Typography variant="caption" component="div"
                            display="block">Заказ нарядов: {data.length}</Typography>

                <Typography variant="caption" component="div"
                            display="block">Рекомендаций: {result.recommendationsCount}</Typography>
                            */}
            </Typography>
        </Alert>
    )

}

export function ListSearchCar({search = {}, status = "success"}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    let storeOrders = useSelector(state => state.lists.listSearch[status]);

    const isValidSearch = useMemo(() => {
        return Boolean((search?.start && search?.end) || search?.plate);
    }, [search]);

    useEffect(() => {
        if (!isValidSearch) {
            dispatch(setListsSearch({status, orders: []}));
            return;
        }

        let cancelled = false;

        (async () => {
            try {
                setLoading(true);
                setError(null);
                const result = await searchCar({...search, status});
                if (!cancelled) {
                    dispatch(setListsSearch({status, orders: result}));
                }
            } catch (e) {
                if (!cancelled) setError("Ошибка при загрузке данных");
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [search, isValidSearch, status]);

    if (!isValidSearch) return <Box/>;
    if (loading) return <LinearProgress sx={{m: 1}}/>;
    if (error) return <Alert severity="error" sx={{m: 1}}>{error}</Alert>;
    if (!storeOrders.length) return <Alert severity="warning" sx={{m: 1}}>Ничего не найдено</Alert>;

    if (search?.start && search?.end && status == "success") {
        const startDate = new Date(search.start);
        const endDate = new Date(search.end);
        endDate.setHours(23, 59, 59);
        startDate.setHours(0, 0, 0);
        storeOrders = storeOrders.filter(item => {
            const orderDate = new Date(item.order_date.replace('Z','')).getTime();
            return orderDate >= startDate.getTime() && orderDate <= endDate.getTime();
        });
    }
    return (
        <>
            <ListStatistics status={status} data={storeOrders}/>
            <VirtualizedCarCard data={storeOrders}/>
        </>
    )
}
